import { setGetProvidersAction } from '../action';
import { getProviders } from '../api/getProviders';

export const setGetProviders = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getProviders(params);
            
            dispatch(setGetProvidersAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}